import { LocalScriptContentProviderOptions, LocalScriptContentProvider } from "../../../typings/local-script-content-provider";

export class NoContentProvider implements LocalScriptContentProvider {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getScriptTextContent(_: LocalScriptContentProviderOptions): string {
        return "";
    }

}
